export default __webpack_public_path__ + "static/media/diskitmonastery.1a1b0cf8.jpg";